// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const ssn: CountryValidator<"US"> = createValidator(
  "us.ssn",
  171,
);

export default ssn;
export const compact = ssn.compact;
export const format = ssn.format;
export const validate = ssn.validate;
export const generate = (): string =>
  ssn.generate?.() ??
  (() => {
    throw new Error(
      "Validator us.ssn cannot generate values",
    );
  })();
